<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('score_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-podium</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-score-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.score.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.score.medium') }}</strong></td>
              <td>
                                    {{ item['medium'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.score.tool') }}</strong></td>
              <td>
                                    {{ item['tool'].name }}
              </td>

              <td><strong>{{ $t('profile.score.quality') }}</strong></td>
              <td>
                                    {{ item['quality'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.score.benchmark') }}</strong></td>
              <td>
                                    {{ item['benchmark'].name }}
              </td>

              <td></td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Score';

export default {
  name: 'ScoreShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('score', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('score', ['find'])
  },
  methods: {
    ...mapActions('score', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
